import { styled as styledStitches } from '@stitches/react';
import { useMemo } from 'react';
import { useElements, useScene } from '../../hooks';
import { useEditor } from '../../hooks/useEditor';
import { LauncherElement } from '../../types/launcherElement';
import { Cursor } from '../common/Cursor';
import { Handle } from '../common/handle/Handle';
import { Element } from '../launcherElements/Element';

export const Scene = () => {
  const scene = useScene();
  const [elements] = useElements<LauncherElement[]>();
  const { launcherThemeSession } = useEditor();

  const LauncherWindow = useMemo(
    () => styledStitches('div', scene?.launcherWindow?.class as {}),
    [scene?.launcherWindow?.class]
  );

  return (
    <div
      style={{
        position: 'relative',
        userSelect: 'none',
        width: scene.launcherWindow.windowWidth,
        height: scene.launcherWindow.windowHeight,
      }}
    >
      {launcherThemeSession.isThemeLoaded ? (
        <LauncherWindow
          id="launcherWindow"
          css={{
            position: 'absolute',
            left: scene.offset.x,
            top: scene.offset.y,
            width: scene.launcherWindow.windowWidth,
            height: scene.launcherWindow.windowHeight,
          }}
        >
          {elements.map((element) => (
            <Element key={element.id} element={element} />
          ))}
        </LauncherWindow>
      ) : (
        <span className="loadingSpinner" />
      )}

      <Cursor />
      <Handle />
    </div>
  );
};
